export const locale = {
    lang: 'pl',
    data: {
        "New": "Nowe",
        "Add template": "Dodaj szablon",
        "Orders history": "Historia zamówień",
        "Add position": "Dodaj pozycję",
        "Product": "Produkt",
        "Unit": "Jednostka",
        "Quantity": "Ilość",
        "Price net": "Cena netto",
        "Price gross": "Cena brutto",
        "Remove": "Usuń",
        "Sale voucher": "Sprzedaj karnet",
        "Voucher sale": "Sprzedaż karnetów",
        "Products sale": "Sprzedaż produktów",
        "Worker": "Pracownik",
        "Description": "Opis",
        "Customer": "Klient",
        "Save": "Zapisz",
        "Vat rate": "VAT",
        "Voucher": "Karnet",
        "Dedication": "Dedykacja",
        "Owner": "Właściciel",
        "Price": "Wartość",
        "Created at": "Data dodania",
        "Actions": "Akcje",
        "Details": "Szczegóły",
        "Name": "Nazwa",
        "Document date": "Data dokumentu",
        "Positions": "Pozycje",
        "Payment method": "Metoda płatności",
        "Create invoice": "Utwórz fakturę",
        "Street": "Ulica",
        "Country": "Kraj",
        "Post code": "Kod pocztowy",
        "City": "Miasto",
        "Line value": "Wartość linii",
        "Order Details": "Szczegóły zamówienia",
        "Products": "Produkty",
        "Invoice": "Faktura",
        "PRODUCT": "PRODUKT",
        "INVOICE": "FAKTURA",
        "PRICE": "CENA",
        "QUANTITY": "ILOŚĆ",
        "TOTAL": "WARTOŚĆ",
        "Phone": "Telefon",
        "Company": "Firma",
        "Printed at": "Data wydrukowania",
        "Read by printer": "Odczytana przez drukarkę",
        "Printed": "Wydrukowana",
        "Yes": "Tak",
        "No": "Nie",
        "Order": "Zamówienie",
        "Add action": "Dodaj akcję",
        "Action key": "Klucz akcji",
        "Is active": "Czy aktywna",
        "Created by": "Dodał",
        "Edit": "Edycja",
        "Service": "Usługa",
        "Add item": "Dodaj usługę",
        "Action data": "Dane akcji",
        "Validity time": "Czas ważności",
        "Delete": "Usuń",
        "Add public API access key": "Dodaj klucz",
        "Access key": "Klucz dostępowy",
        "Public API access data": "Dane klucza dostępu do publicznego API",
        "Are you sure you want to delete selected public API access key?": "Czy na pewno chcesz usunąć wybrany klucz dostępu do API publicznego?",
        "Message templates": "Szablony wiadomości",
        "Message template data": "Dane szablonu wiadomości",
        "Color": "Kolor",
        "Click and set the color.": "Kliknij i ustaw kolor.",
        "Basic data": "Dane podstawowe",
        "Voucher template group": "Grupa karnetów",
        "New voucher": "Nowy karnet",
        "New group": "Nowa grupa",
        "Sorting": "Sortowanie",
        "Active templates": "Aktywne szablony",
        "Template group data": "Dane grupy szablonów",
        "Voucher groups": "Grupy karnetów",
        "Voucher template groups": "Grupy karnetów",
        "Images": "Obrazy",
        "Drag and drop file here": "Przeciągnij i upuść plik tutaj",
        "or": "lub",
        "Browse for file": "Wyszukaj plik",
        "Is background": "Obraz jest tłem",
        "Is fill": "Obraz jest wypełnieniem",
        "Alt name": "Alternative text",
        "Destination": "Przeznaczenie",
        "Page": "Strona",
        "Mobile application": "Aplikacja mobilna",
        "WWW Shop": "Sklep internetowy",
        "Saving": "Zapisywanie"
    }
};
